// js
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';


const ParentDSALink = ({ dsa }) => {
  const labelText = dsa.dsa.converted ? 'Cloned To Full' : 'Cloned';

  if (dsa.dsa.parent) {
    return (
      <div className='ParentDSALink'>
        <span>{labelText}: </span>
        <Link to={`/account/${dsa.account.sfid}/dsa/${dsa.dsa.parent}/sources`}>
          View Original Assessment
        </Link>
      </div>
    );
  }
};

ParentDSALink.propTypes = {
  dsa: PropTypes.object.isRequired
};

export default ParentDSALink;



// WEBPACK FOOTER //
// ./src/components/account/ParentDSALink.js